const headerDropdown = () => {
  const dropdowns = document.getElementsByClassName('header__nav-item--with-dropdown');

  Array.prototype.filter.call(dropdowns, function (dropdown) {
    dropdown.addEventListener(
      'mouseenter',
      function (event) {
        // console.log('enter');
        const mainSection = document.getElementsByClassName('main')[0];
        mainSection.classList.add('main--navbar-opened');
      },
      false
    );

    dropdown.addEventListener(
      'mouseleave',
      function (event) {
        const mainSection = document.getElementsByClassName('main')[0];
        mainSection.classList.remove('main--navbar-opened');
      },
      false
    );
  });
};

export default headerDropdown;
